import { Icon } from "@2u-landing-pages/components/Icon";
// @ts-ignore
import style from "./Pagination.module.scss";

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
  const pageNumbers: number[] = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  if (totalPages <= 1) return null;

  return (
    <nav>
      <ul className={style.pagination}>
        <li className={`page-item ${currentPage === 1 ? style.disabled : ""}`}>
          <button className={style.pageLink} onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
            <Icon name="chevron-left" size="lg" />
          </button>
        </li>
        {pageNumbers.map((number) => (
          <li key={number} className={`page-item ${currentPage === number ? style.pageLinkActive : ""}`}>
            <button className={style.pageLink} onClick={() => onPageChange(number)}>
              {number}
            </button>
          </li>
        ))}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className={style.pageLink}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <Icon name="chevron-right" size="lg" />
          </button>
        </li>
      </ul>
    </nav>
  );
};
